<template>
    <div>
        
        <div class="is-size-3 has-text-centered">TAGS</div>
        <tags-input class="top20" element-id="tags"
            v-model="selectedTags"
            :existing-tags="{ 
                'web-development': 'Web Development',
                'php': 'PHP',
                'javascript': 'JavaScript',
            }"
            :typeahead="true">
        </tags-input>

        <div class="is-size-3 has-text-centered top60">TAG GROUPS</div>

        <div class="tagGroup" draggable>
            Travel | City | Hotel
        </div>
         <div class="tagGroup"  draggable>
            Restaurant | Italian 
        </div>
         <div class="tagGroup"  draggable>
            Music | Jazz | Trio
        </div>


    </div>
</template>

<script>

import VoerroTagsInput from '@voerro/vue-tagsinput';
export default{
    name: 'tag-bar',
    components:{"tags-input": VoerroTagsInput},
    data: function(){
        return {
                selectedTags: [
                    'tags',
                    'selected',
                    'by',
                    'default',
                ]
            }
    }
}

</script>